import { cx } from "./ui";

/** Illustration only, with fixed example times: which open time BTB rules look at, and which they never do. */
const SEGMENTS = [
  { width: "17.3%", kind: "open", label: "Open at start", short: "Start", note: "1.5 hours" },
  { width: "28.25%", kind: "appt", label: "Appointment", short: "Booked", note: null },
  { width: "10.2%", kind: "gap", label: "Gap", short: "Gap", note: "not counted" },
  { width: "28.25%", kind: "appt", label: "Appointment", short: "Booked", note: null },
  { width: "16%", kind: "open", label: "Open at end", short: "End", note: "1.5 hours" },
] as const;

// Figma: open time green with a dark-green edge on the shift side, appointments blue, the gap grey.
const TONE = {
  open: "bg-hs-open text-hs-open-ink",
  appt: "bg-hs-info-soft text-hs-info",
  gap: "bg-hs-divider text-hs-gap-ink",
} as const;

export function OpenTimeTimeline() {
  return (
    <div role="img" aria-label="Example shift from 9:00 to 5:00. Open from 9:00 to 10:30 counts, the gap from 1:00 to 2:00 between appointments does not count, open from 3:30 to 5:00 counts.">
      <div aria-hidden="true" className="flex h-[67px] overflow-hidden rounded-2xl text-sm font-semibold">
        {SEGMENTS.map((s, i) => (
          <div key={i} style={{ width: s.width }} className={cx("flex flex-col items-center justify-center px-1 text-center leading-tight", TONE[s.kind], s.kind === "open" && (i === 0 ? "border-r-2 border-hs-open-ink" : "border-l-2 border-hs-open-ink"))}>
            <span className="truncate"><span className="sm:hidden">{s.short}</span><span className="hidden sm:inline">{s.label}</span></span>
            {s.note && <span className={cx("truncate font-medium", s.kind === "gap" && "hidden sm:inline")}>{s.note}</span>}
          </div>
        ))}
      </div>
      <div aria-hidden="true" className="mt-2 flex justify-between text-sm font-medium text-hs-text-muted">
        <span>Shift starts 9:00</span><span className="hidden sm:inline">10:30</span><span className="hidden sm:inline">1:00</span><span className="hidden sm:inline">2:00</span><span className="hidden sm:inline">3:30</span><span>Shift ends 5:00</span>
      </div>
    </div>
  );
}
